<template>
  <vs-popup :title="title" :active.sync="popupOpen">
    <h5 class="mb-4 flex items-center">
      <feather-icon icon="CheckCircleIcon" class="mr-4" svg-classes="text-success"/>
      Всего добавлено: {{info.successAdded}}
    </h5>
    <h5 class="mb-4 flex items-center">
      <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger"/>
      Апартаментов не найдено: {{info.errorNoApartment}}
    </h5>
    <h5 class="mb-4 flex items-center">
      <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger"/>
      Приборов не найдено: {{info.errorNoDevice}}
    </h5>
    <h5 class="mb-4 flex items-center">
      <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger"/>
      Количество приборов одного типа: {{info.errorManyDevices}}
    </h5>
  </vs-popup>
</template>

<script>
  export default {
    name: "HeaterValuesImportPopup",
    props: {
      title: {
        default: null
      },
      isOpen: {
        default: false,
      },
      info: {
        default: null,
      }
    },
    computed: {
      popupOpen: {
        get(){
          return this.isOpen;
        },
        set(value){
          this.$emit('openChanged', value);
        }
      }
    }
  }
</script>

<style scoped>

</style>